var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.multiType)?_c('div',[_c('show-more-cell',{attrs:{"row":_vm.row,"showElliptical":true,"show":_vm.column.commissionShow}})],1):_c('div',[_c('el-tag',{staticClass:"mr-4",attrs:{"useByTable":false}},[_vm._v(_vm._s(_vm.row.productTypeName))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }